// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addNewItemsStyles } from "@awc/App/Components/MyListsDetails/AddNewItems";
import { modalButtonsActionStyles } from "@awc/XDL/Utilities";
import { css } from "styled-components";

addNewItemsStyles.orderUploadGridItem = {
    width: [12, 12, 6, 6, 6],
};

addNewItemsStyles.uploadInstructionsGridItem = {
    width: [12, 12, 6, 6, 6],
};

addNewItemsStyles.actionButton = {
    variant: "primary",
    css: css`
        white-space: nowrap;
    `,
};

addNewItemsStyles.productSelectorModal = {
    sizeVariant: "medium",
};

addNewItemsStyles.actionsWrapper = {
    css: css`
        display: flex;
        margin-top: 20px;
        justify-content: end;
        gap: 10px;
    `,
};

addNewItemsStyles.uploadItemsButton = modalButtonsActionStyles.submitButton;

addNewItemsStyles.cancelButton = modalButtonsActionStyles.cancelButton;

addNewItemsStyles.productSelectorStyles = {
    unitOfMeasureGridItem: {
        css: css`
            width: auto;
        `,
    },
    buttonGridItem: {
        width: [12, 6, 6, 2, 2],
    },
    selectButton: {
        variant: "tertiary",
    },
};
